exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-margin-new {\n  padding: 4px 10px;\n  height: 31px;\n  display: inline-flex;\n  border-radius: 5px;\n  margin: 5px;\n}\n", ""]);

// exports
